export const OVER_CONFLUENT_THRESHOLD = 80

export type IssueType = 'OVER_CONFLUENT' | 'CELL_DEATH'
